import React from 'react';
import { Link } from 'react-router-dom';
import { Gem, AlertTriangle } from 'lucide-react';

export const OneOfAKindPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="one-of-a-kind-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="one-of-a-kind-title">One-of-a-Kind Items Policy</h1>
          <p className="text-lg text-softgrey">Every piece tells a unique story.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-coral/10 border-2 border-coral/30 p-8 rounded-xl" data-testid="unique-notice">
            <div className="flex items-center gap-3 mb-4">
              <Gem className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Unique Vintage Pieces</h2>
            </div>
            <p className="text-softgrey leading-relaxed text-lg">Items are unique and not restocked. Once sold, they are gone forever.</p>
          </section>

          <section data-testid="what-this-means">
            <div className="flex items-center gap-3 mb-4">
              <AlertTriangle className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">What This Means</h2>
            </div>
            <ul className="list-disc list-inside space-y-3 text-softgrey ml-2">
              <li>When a product shows <strong>"Only 1 available"</strong> - that's it</li>
              <li>We cannot reorder or source the same item again</li>
              <li>This is what makes vintage shopping special - you own a piece of fashion history that no one else has</li>
            </ul>
          </section>

          <section data-testid="stay-updated">
            <h2 className="text-2xl font-heading font-bold mb-4">Stay Updated</h2>
            <p className="text-softgrey leading-relaxed">We add new items regularly. Check back often or sign up for our newsletter to be first to see new arrivals!</p>
            <Link to="/shop" className="inline-block mt-4 text-coral hover:underline font-semibold">Browse Our Collection →</Link>
          </section>
        </div>
      </div>
    </div>
  );
};
